import { useEffect, useState } from "react";
import {
  Container,
  Grid,
} from "@mui/material";
import Profile from "./Profile";
import QrCode from "./QrCode";
import Points from "./Points";
import Accomplished from "./Accomplished";
import Prizes from "./Prizes";
import { useAuth } from "../../contexts/AuthContext";
import { useLocation } from "react-router";
import Achievements from "./Achievements";
import { db } from "../../firebase";
import Skelet from "../Skelet";

import { Redirect } from "react-router-dom";
import NavBar from "../NavBar";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Dashboard() {
  const { currentUser } = useAuth();
  const [uid, setUid] = useState(currentUser.uid);
  const [player, setPlayer] = useState(null);
  const [prizes, setPrizes] = useState(null);
  const [done, setDone] = useState(null);
  const [unDone, setUndone] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);
  const [prizeLoading, setPrizeLoading] = useState(true);
  const [redirectToRegister, setRedirectToRegister] = useState();
  const [user, setUser] = useState(null);

  let query = useQuery();

  useEffect(() => {
    if (query.get("id") !== null) {
      setUid(query.get("id"));
    } else {
      setUid(currentUser.uid);
    }
  }, [uid])

  useEffect(() => {
    if (uid !== undefined) {
      db.collection("users").doc(uid)
          .onSnapshot((doc) => {
            if (doc.exists) {
              setPlayer(doc.data());

              setProfileLoading(false);
            }
          });
    }

    db.collection("users").doc(currentUser.uid)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setUser(doc.data());
            setProfileLoading(false);
          }else{
            setRedirectToRegister(true);
          }
        });


    db.collection("prizes")
        .get()
        .then((item) => {
          const items = item.docs.map((doc) => doc);
          setPrizes(items);


          setPrizeLoading(false);
        });

    db.collection("accomplished")
        .where("userId", "==", uid)
        .onSnapshot(async (junctions) => {
          const doneAchievements = junctions.docs.map((doc) => doc.data().achievementId);
          const undone = [];
          const done = [];
          const achievements = await db.collection("achievements").get();
          achievements.forEach((doc) => {
            if (!doneAchievements.includes(doc.id)) {
              undone.push(doc);
            }else {
              done.push(doc);
            }
          });

          setDone(done);
          setUndone(undone);
        });



  }, [uid]);

  let pointsData = <Skelet />;
  let profileData = <Skelet />;
  let accomplishedData = <Skelet />;
  let achievementsData = <Skelet />;
  let prizesData = <Skelet />;

  const renderPoints = (points) => {
    return <Points points={points} />;
  };

  const renderProfile = (profile, id, currUser) => {
    return <Profile currentUser={currUser} user={profile} uid={id} />;
  };

  const renderPrizes = (prizes, id, currUser) => {
    return <Prizes currentUser={currUser} uid={id} prizes={prizes} />;
  };

  const renderAccomplished = (admin, id, invited) => {
    return <Accomplished achievements={done} invited={invited} uid={id} isAdmin={admin} />;
  };

  const renderAchievements = (admin, id) => {
    return <Achievements undoneAchievements={unDone} uid={id} isAdmin={admin} />;
  };

  try {
    if (player !== undefined && uid !== null) {
      pointsData = renderPoints(player.points);
      profileData = renderProfile(player, uid, currentUser);
      prizesData = renderPrizes(prizes, uid, currentUser);
    }

    if (player.isAdmin !== null && uid !== null) {
      accomplishedData = renderAccomplished(user.isAdmin, uid, player.invited);
      achievementsData = renderAchievements(user.isAdmin, uid);
    }
  } catch (e) {}

  return (
    <>
      <Container sx={{ marginTop: 2, marginBottom: 2 }}>
        <Grid container spacing={2}>
          <Grid item md={3} xs={12}>
            <QrCode uid={uid} />
          </Grid>

          <Grid item md={6} xs={12}>
            {profileLoading ? <Skelet /> : profileData}
          </Grid>

          <Grid item md={3} xs={12}>
            {profileLoading ? <Skelet /> : pointsData}
          </Grid>

          <Grid item md={4} xs={12}>
            {accomplishedData}
          </Grid>

          <Grid item md={4} xs={12}>
            {achievementsData}
          </Grid>

          <Grid item md={4} xs={12}>
            {prizeLoading ? <Skelet /> : prizesData}
          </Grid>
        </Grid>
      </Container>

      {redirectToRegister ? (
        <Redirect to={"/register?id=" + currentUser.uid} />
      ) : null}
    </>
  );
}

export default Dashboard;
